import { L } from '@lib';
import {
  lettersOnlyNoSpacesStartRegex,
  lettersAndNumbersOnlyNoSpacesStartRegex,
  phoneNumberRegex,
  vehicleRegNumberUKRegex,
  websiteRegex,
  postodeRegex,
  sortCodeRegex,
  vatRegex,
} from './regularExpressions';

export const Rules = {
  required: [{ required: true, message: L('Required') }],
  shared: [
    { required: true, message: L('Required') },
    {
      pattern: lettersAndNumbersOnlyNoSpacesStartRegex,
      message: L('No empty spaces or special characters'),
    },
  ],
  lettersOnly: [
    { required: true, message: L('Required') },
    {
      pattern: lettersOnlyNoSpacesStartRegex,
      message: L('No empty spaces, numbers or special characters'),
    },
  ],
  email: [
    { required: true, message: L('Required') },
    { type: 'email', message: L('Not a valid email') },
  ],
  emailNotRequired: [{ type: 'email', message: L('Not a valid email') }],
  phone: [
    { required: true, message: L('Required') },
    { pattern: phoneNumberRegex, message: L('Not a valid phone') },
  ],
  phoneNotRequired: [{ pattern: phoneNumberRegex, message: L('Not a valid phone') }],
  website: [
    {
      pattern: websiteRegex,
      message: L('Not a valid website address'),
    },
  ],
  postcode: [
    { required: true, message: L('Required') },
    { pattern: postodeRegex, message: L('Not a valid postcode') },
  ],
  vehicleRegNumberUK: [
    { required: true, message: L('Required') },
    { pattern: vehicleRegNumberUKRegex, message: L('Not a valid registration number') },
  ],
  sortCode: [{ pattern: sortCodeRegex, message: L('Not a valid sort code') }],
  vat: [
    { required: true, message: L('Required') },
    { pattern: vatRegex, message: L('Not a valid VAT') },
  ],
};
